export enum EDruhVynosu {
    P = 'P',
    KP = 'KP',
    PC = 'PC',
    KPC = 'KPC',
    PR = 'PR',
    N = 'N',
    A = 'A'
}
